import Vue from 'vue';
import App from './App';
import router from './router'
import vuetify from './plugins/vuetify';
import store from './store'
import LoadScript from 'vue-plugin-load-script';
import gtagjs from 'vue-gtagjs';

Vue.use(LoadScript);
Vue.config.productionTip = true;
if(process.env.VUE_APP_GOOGLE_ANALYTIC != '')
{
    gtagjs(router, process.env.VUE_APP_GOOGLE_ANALYTIC, { debug: process.env.NODE_ENV !== 'production', scriptId: 'gtagjs'});
}
new Vue({
    store,
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app');
